import { phoneRegex } from "../validationRegex";
export const isValidPhoneNumber = (value) => {
    if (!value)
        return false;
    return phoneRegex.test(value.trim());
};
